var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.menu)?_c('pages-core-app-bar'):_vm._e(),_c('pages-core-view',{style:(_vm.overflow ? 'overflow: auto; ' : 'overflow: hidden; height: 100vh;'),attrs:{"fullscreen":_vm.fullscreen}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }